import {Button, Form, Modal} from "semantic-ui-react";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../app/hooks";
import {CreateNewCounter, UpdateCounter} from "./TablesActions";
import {RootState} from "../../app/store";
import {useSelector} from "react-redux";
import {ICounterTable} from "../../interfaces/CounterTable";
import { useTranslation } from "react-i18next";
interface ICounterModal {
  open: boolean;
  row: ICounterTable;
  updateRow: boolean;
  onClose: () => void;
}

export const CounterModal = ({open, row, updateRow, onClose}: ICounterModal) => {
  const [newRow, setNewRow] = useState<ICounterTable>(emptyRow);
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<{[key: string]: string}>({});
  const {companyId} = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();
  useEffect(() => {
    if (updateRow) {
      setNewRow(row);
    } else {
      setNewRow(emptyRow);
    }
  }, [row, updateRow]);

  const onCheckBoxChange = (e: any, data: any) => {
    setErrors({...errors, isSscc: "", len: ""});
    setNewRow({...newRow, [data.name]: data.checked ? 1 : 0, len: data.checked ? 18 : 0}); //if sscc - len is 18
  };

  const onInputChange = (e: any) => {
    const {name, value} = e.target;
    setErrors({...errors, [name]: ""});
    if (name === "len" || name === "nextValue") {
      if (value !== "" && !isNaN(Number(value))) {
        setNewRow({...newRow, [name]: parseInt(value)});
      } else if (value === "") {
        setNewRow({...newRow, [name]: undefined});
      }
    } else {
      setNewRow({...newRow, [name]: value});
    }
  };

  const validateForm = () => {
    let errors = {};
    if (newRow.name === "") {
      errors = {...errors, name: t("counter_empty_err")};
    } else if (newRow.name.length > 20) {
      errors = {...errors, name: t("counter_long_err")};
    }
    if (newRow.isSscc === 1 && newRow.len !== 18 && newRow.len !== 17) {
      errors = {...errors, len: t("counter_sscc_err")};
    }
    if (newRow.prefix.length > 18) {
      errors = {...errors, prefix: t("prefix_long_err")};
    }

    if (newRow.len < 1) {
      errors = {...errors, len: t("length_small_err")};
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const onSubmit = () => {
    if (validateForm()) {
      if (updateRow) {
        dispatch(UpdateCounter(newRow, companyId));
      } else {
        dispatch(CreateNewCounter(newRow, companyId));
      }
      onHide();
    }
  };
  const onHide = () => {
    setNewRow(emptyRow);
    setErrors({});
    onClose();
  };
  return (
    <Modal size="small" closeIcon onClose={onHide} open={open}>
      <Modal.Header> {!updateRow ? t("create_new_counter") : t("update_counter")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          <Form.Field required>
            <label>{t("counter")}</label>
            <Form.Input
              maxLength={20}
              autoFocus={!updateRow}
              placeholder={t("counter")}
              required
              name="name"
              value={newRow.name === undefined || newRow.name === null ? "" : newRow.name}
              onChange={onInputChange}
              disabled={updateRow}
              error={errors.name ? {content: errors.name} : false}
            />
          </Form.Field>
          <Form.Field error={errors.isSscc !== undefined && errors.isSscc !== ""}>
            <Form.Checkbox label={t("is_sscc")} name="isSscc" checked={newRow.isSscc === 1} onChange={onCheckBoxChange} />
          </Form.Field>
          <Form.Field required>
            <label>{t("length")}</label>
            <Form.Input
              required
              placeholder={t("length")}
              name="len"
              //disabled={newRow.isSscc === 1}
              value={newRow.len === undefined || newRow.len === null ? "" : newRow.len}
              onChange={onInputChange}
              error={errors.len && errors.len !== "" ? {content: errors.len} : false}
            />
          </Form.Field>
          <Form.Field required>
            <label>{t("prefix")}</label>
            <Form.Input
              required
              placeholder={t("prefix")}
              maxLength={18}
              name="prefix"
              value={newRow.prefix === undefined || newRow.prefix === null ? "" : newRow.prefix}
              onChange={onInputChange}
              error={errors.prefix ? {content: errors.prefix} : false}
            />
          </Form.Field>
          <Form.Field required>
            <label>{t("next_value")}</label>
            <Form.Input
              required
              placeholder={t("next_value")}
              name="nextValue"
              value={newRow.nextValue === undefined || newRow.nextValue === null ? "" : newRow.nextValue}
              onChange={onInputChange}
              error={errors.nextValue ? {content: errors.nextValue} : false}
            />
          </Form.Field>
          <button type="submit" style={{display: "none"}} aria-hidden="true"></button>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
        {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onSubmit}>
          {!updateRow ? t("create_btn") : t("update_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const emptyRow: ICounterTable = {
  name: "",
  isSscc: 0,
  len: 0,
  prefix: "",
  nextValue: 1,
  companyId: 0,
};
